import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import HomePage from "./pages/HomePage";
import SuperAdminPage from "./pages/SuperAdminPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./pages/Login/Login";
import { useEffect } from "react";
import Cookies from "universal-cookie";

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

function App() {
  const location = useLocation();
  const cookies = new Cookies();
  const token = cookies.get("hts-tok");
  const role = cookies.get("hts-role");
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to login if not on login page and token is missing
    if (!token && location.pathname !== "/login" && location.pathname !== "/home") {
      navigate("/home");
    }
  }, [token, location.pathname, navigate]);

  const hideHeaderRoutes = ["/login"]; // list of routes where header should be hidden
  const shouldShowHeader = !hideHeaderRoutes.includes(location.pathname);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      {shouldShowHeader && <Header />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<HomePage />} />
        {role === "HTS_ADMIN" && (
          <Route path="/chapters" element={<SuperAdminPage />} />
        )}
        {/* Optional fallback route for other users trying to access /chapters */}
        {role !== "HTS_ADMIN" && (
          <Route path="/chapters" element={<Navigate to="/home" replace />} />
        )}
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default AppWrapper;
